import React, { useState, useEffect } from "react";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { Link } from "react-router-dom";
import { changePassword } from "../../api/api";

const PasswordChange = (props) => {
  const newPassword = useFormInput("");
  const { id } = props.location.state;
  const oldPassword = useFormInput("");

  useEffect(() => {}, []);
  const handleSubmit = async (event) => {
    event.preventDefault();
    const oPassword = oldPassword.value;
    const nPassword = newPassword.value;
    const _id = id;

    /* eslint-disable no-unused-vars */

    const result = await changePassword(oPassword, nPassword, _id).then(
      (result) => {
        toastr.success("Successfully Saved", "Success");
      },
      (error) => {
        toastr.error(error.response.data.error.message, "Error");
      }
    );
    /* eslint-disable no-unused-vars */
  };

  return (
    <div className="Main-page">
      <div className="login-box" style={{ marginLeft: 300, marginTop: 100 }}>
        <div className="login-logo">
          <Link to="index.html" style={{ color: "#ee3c2c" }}>
            SM
            <i
              className="far fa-play-circle fa-spin"
              style={{ color: "#ee3c2c" }}
            ></i>
            <b>TT</b>
          </Link>
        </div>
        <div className="card trans">
          <div className="card-body login-card-body trans">
            <p className="login-box-msg">Change Password</p>

            <form onSubmit={handleSubmit}>
              <div className="input-group mb-3">
                <input
                  type="password"
                  name="password"
                  className="form-control trans"
                  placeholder="Old Password"
                  {...oldPassword}
                  required
                  autoComplete="off"
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-lock"></span>
                  </div>
                </div>
              </div>
              <div className="input-group mb-3">
                <input
                  type="password"
                  name="password"
                  className="form-control trans"
                  placeholder="New Password"
                  {...newPassword}
                  required
                  autoComplete="off"
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-lock"></span>
                  </div>
                </div>
              </div>

              {/* <div className="input-group mb-3">
<input type="password" name="password" className="form-control trans" placeholder="Confirm Password"  required autoComplete="off"/>
<div className="input-group-append">
<div className="input-group-text">
<span className="fas fa-lock"></span>
</div>
</div>
</div> */}
              <div className="row">
                <div className="col-8"></div>
                <div className="col-4">
                  <button type="submit" className="btn btn-primary btn-block">
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

const useFormInput = (initialValue) => {
  const [value, setValue] = useState(initialValue);

  const handleChange = (e) => {
    setValue(e.target.value);
  };
  return {
    value,
    onChange: handleChange,
  };
};

export default PasswordChange;
